import { c as _c } from "react/compiler-runtime";
import "client-only";
import type { AppBridgeEvent } from "@/vendors/webview/bridge/app-bridge/AppBridgeEvent";
import { sendAppBridgeEvent, sendAppBridgeEventAsync } from "@/vendors/webview/bridge/app-bridge/SendAppBridgeEvent";
import { useWebview } from "@/vendors/webview/context/webview-client.context";
type UseAppBridge = {
  readonly isAvailable: boolean;
  readonly login: () => void;
  readonly manageAppTrackingTransparencySettings: () => void;
  readonly manageUser: () => void;
  readonly manageUserUrl: () => Promise<{
    readonly url?: string;
  } | undefined>;
  readonly signup: () => void;
  readonly navigateToArticle: (props: {
    readonly url: string;
    readonly id: string;
    readonly imageUrl?: string;
    readonly sectionTitle?: string;
  }) => void;
  readonly navigateToPage: (url: string) => void;
};
export function useAppBridge() {
  const $ = _c(2);
  const {
    isWebview
  } = useWebview();
  const isAvailable = isWebview && typeof window !== "undefined";
  const login = _temp;
  const manageAppTrackingTransparencySettings = _temp2;
  const signup = _temp3;
  const manageUser = _temp4;
  const manageUserUrl = _temp5;
  const navigateToArticle = _temp6;
  const navigateToPage = _temp7;
  let t0;
  if ($[0] !== isAvailable) {
    t0 = {
      isAvailable,
      login,
      manageAppTrackingTransparencySettings,
      manageUser,
      manageUserUrl,
      navigateToArticle,
      navigateToPage,
      signup
    };
    $[0] = isAvailable;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}
function _temp7(url) {
  const event_5 = {
    action: "navigate.general",
    data: {
      navType: "page",
      url
    }
  };
  sendAppBridgeEvent(event_5);
}
function _temp6(props) {
  const event_4 = {
    action: "navigate.article",
    data: {
      data: {
        action: {
          articleImageUrl: props.imageUrl,
          shareUrl: props.url
        },
        articleId: props.id,
        sectionTitle: props.sectionTitle
      },
      url: props.url
    }
  };
  sendAppBridgeEvent(event_4);
}
async function _temp5() {
  const event_3 = {
    action: "user.getManageAccountUrl"
  };
  return sendAppBridgeEventAsync(event_3);
}
function _temp4() {
  const event_2 = {
    action: "user.manageAccount"
  };
  sendAppBridgeEvent(event_2);
}
function _temp3() {
  const event_1 = {
    action: "user.signup"
  };
  sendAppBridgeEvent(event_1);
}
function _temp2() {
  const event_0 = {
    action: "consent.manage"
  };
  sendAppBridgeEvent(event_0);
}
function _temp() {
  const event = {
    action: "auth.login"
  };
  sendAppBridgeEvent(event);
}